import { push } from 'redux-first-history';
import { buildRoute } from '../utils/routes';
import { CHANGE_TO_NEXT_STEP_FOR_PRELOADED_CUSTOMER } from './index';

export default function changeToNextStepForPreloadedCustomer() {
  return (dispatch, getState) => {
    const {
      group: { slug, configurableFields },
      selectedDevices: { model },
    } = getState();

    dispatch({ type: CHANGE_TO_NEXT_STEP_FOR_PRELOADED_CUSTOMER });

    let nextRoute = '';
    if (model.colors.length) {
      nextRoute = 'color';
    } else if (configurableFields.length) {
      nextRoute = 'configurable-fields';
    } else {
      nextRoute = 'issue';
    }

    dispatch(push(buildRoute(slug, nextRoute)));

    return Promise.resolve();
  };
}
